export * from "@common/hocs/withDropdown/index";

import "./style.less";

import withDropdownHOC from "@common/hocs/withDropdown/index";
export default withDropdownHOC;
